import styled from 'styled-components';
import { breakpoints } from '@styles/index';
import P1 from '@base/P1/P1';
import H1 from '@base/H1/H1';
import H4 from '@base/H4/H4';

export const StyledButton = styled.button`
  background-color: #08bd80;
  color: #fff;
  border: none;
  border-radius: 4px;
  height: 56px;
  font-weight: bold;
  cursor: pointer;
  grid-column: span 12;
  padding: 16px 32px;
  min-width: 201px;
  display: ${({ $hideLg }) => ($hideLg ? 'none' : 'block')};
  @media (max-width: ${breakpoints.tablet}) {
    height: 48px;
    width: auto;
    display: ${({ $hideMd }) => ($hideMd ? 'none' : 'block')};
  }
  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
    height: 48px;
    display: ${({ $hideSm }) => ($hideSm ? 'none' : 'block')};
  }
`;

export const Caption = styled(P1)`
  color: #627984;
  margin-bottom: 8px;
  font-weight: 600;
  @media (max-width: ${breakpoints.tablet}) {
    font-size: 12px;
    line-height: 100%;
    margin-bottom: 4px;
  }
`;

export const Title = styled(H1)`
  font-size: 40px;
  line-height: 44px;
  margin-bottom: 16px;
  @media (max-width: ${breakpoints.tablet}) {
    font-size: 24px;
    line-height: 130%;
    margin-bottom: 8px;
  }
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 24px;
    line-height: 120%;
  }
`;

export const Description = styled(P1)`
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 32px;
  @media (max-width: ${breakpoints.tablet}) {
    font-size: 16px;
    line-height: 150%;
    margin-bottom: 24px;
  }
`;

const Container = styled.div`
  width: 1136px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  column-gap: 16px;
  place-items: center;
  @media (max-width: ${breakpoints.tablet}) {
    width: 728px;
  }
  @media (max-width: ${breakpoints.mobile}) {
    display: block;
    width: 100%;
    padding: 0;
  }
`;

export const Feature = styled.section`
  margin-top: 96px;
  grid-column: span 8;
  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 0;
  }
`;

export const CardLogo = styled.div`
  border-radius: 8px;
  margin-bottom: 24px;
  @media (max-width: ${breakpoints.mobile}) {
    margin-bottom: 0;
  }
`;

export const CardTitle = styled(H4)`
  margin-bottom: 8px;
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 16px;
    line-height: 150%;
    margin-bottom: 0;
    margin-left: 12px;
  }
`;

export const CardDescription = styled(P1)``;

export default Container;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
